import { ButtonColor } from '@ui/buttons/get-shared-button-style';
import { useSettings } from '@ui/settings/use-settings';
import { useNavigate } from '@common/ui/navigation/use-navigate';
import { Menu, MenuTrigger } from '@ui/menu/menu-trigger';
import { IconButton } from '@ui/buttons/icon-button';
import { PersonIcon } from '@ui/icons/material/Person';
import { Item } from '@ui/forms/listbox/item';
import { Trans } from '@ui/i18n/trans';
import { Link } from 'react-router-dom';
import { Button } from '@ui/buttons/button';
import { NavbarProps } from '@common/ui/navigation/navbar/navbar';
import { Fragment,useState } from 'react';

interface NavbarAuthButtonsProps {
  primaryButtonColor?: ButtonColor;
  navbarColor?: NavbarProps['color'];
}
export function NavbarAuthButtons({
  primaryButtonColor,
  navbarColor,
}: NavbarAuthButtonsProps) {
  if (!primaryButtonColor) {
    primaryButtonColor = navbarColor === 'primary' ? 'paper' : 'primary';
  }

  return (
    <Fragment>
      <MobileButtons />
      <DesktopButtons primaryButtonColor={primaryButtonColor} />
    </Fragment>
  );
}

interface DesktopButtonsProps {
  primaryButtonColor: ButtonColor;
}
function DesktopButtons({ primaryButtonColor }: DesktopButtonsProps) {
  const { registration } = useSettings();
  const [hover, setHover] = useState(false);
  const isLandingPage = location.pathname === '/';
  const isDark = document.documentElement.classList.contains("dark");
  return (
    <div className="hidden md:flex items-center gap-4">
    <Button
          elementType={Link}
          to="/login"
          variant="raised"
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
          style={{
               background: hover
              ? "transparent"
              : "transparent",

            color: hover
              ? "#3b82f6"
              : isDark
              ? "#93c5fd"
              : "#1e3a8a",
            height: "auto",
            fontSize: "1rem",
            border: `1px solid ${isDark ? "#3b82f6" : "#1e3a8a"}`,
            borderRadius: "0.8rem",
            padding: "12px 30px",
            fontWeight: "bold",
            cursor: "pointer",
            transition: "all 0.3s ease-in-out",
            fontFamily: "'Inter', serif"
          }}
        >
          <Trans message="Login" />
        </Button>


      {!registration?.disable && (
        <Button
          elementType={Link}
          to="/register"
          variant="text"
          className="ml-10 btn h-auto text-white font-semibold
             bg-gradient-to-r from-[#0072ff] to-[#00c6ff] 
             shadow-lg transition-all duration-300 
             hover:from-[#0059d6] hover:to-[#00aaff] 
             hover:shadow-2xl "
        >
          <Trans message="Register" />
        </Button>
      )}
    </div>
  );
}

function MobileButtons() {
  const { registration } = useSettings();
  const navigate = useNavigate();
  const isDark = document.documentElement.classList.contains("dark");
  
  return (
    <MenuTrigger>
      <IconButton size="md" className="md:hidden text-black"
      style={{ color: isDark ? '#ffffff' : '#000000' }}>
        <PersonIcon />
      </IconButton>
      <Menu>
        <Item value="login" onSelected={() => navigate('/login')}>
          <Trans message="Login" />
        </Item>
        {!registration?.disable && (
          <Item value="register" onSelected={() => navigate('/register')}>
            <Trans message="Register" />
          </Item>
        )}
      </Menu>
    </MenuTrigger>
  );
}